import WebHIDTypes from './webHID.types';
import { IDevice  } from "@gnaudio/jabra-js";

export type WebHIDAction =
    | { type: typeof WebHIDTypes.SHOW_WEBHID_PAIR_BUTTON}
    | { type: typeof WebHIDTypes.HIDE_WEBHID_PAIR_BUTTON}
    | { type: typeof WebHIDTypes.SET_WEBHID_IN_CALL, payload: boolean}
    | { type: typeof WebHIDTypes.SET_IGNORE_DEVICE_SIGNALS, payload: boolean}
    | { type: typeof WebHIDTypes.SET_CONNECTED_HEADSET, payload: Partial<IDevice>}
    

export function showWebHIDPairButton(): WebHIDAction {
    return {
        type: WebHIDTypes.SHOW_WEBHID_PAIR_BUTTON,
    };
}

export function hideWebHIDPairButton(): WebHIDAction {
    return {
        type: WebHIDTypes.HIDE_WEBHID_PAIR_BUTTON,
    };
}


export function setWebHIDInCall(currentlyInCall: boolean): WebHIDAction {
    return {
        type: WebHIDTypes.SET_WEBHID_IN_CALL,
        payload: currentlyInCall
    }
}
export function setIgnoreDeviceSignals(shouldIgnore: boolean): WebHIDAction {
    return {
        type: WebHIDTypes.SET_IGNORE_DEVICE_SIGNALS,
        payload: shouldIgnore
    }
}
export function setConnectedHeadset(devices: Partial<IDevice>) {
    return {
        type: WebHIDTypes.SET_CONNECTED_HEADSET,
        payload: devices
    }
}